export function range(start: number, end: number, step = 1) {
    const r: number[] = [];
    for (let i = start; i <= end; i += step) {
        r.push(i);
    }
    return r;
}

export default range;
